import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import LandingPage from "@/pages/LandingPage";
import StartFormPage from "@/pages/StartFormPage";
import AssignmentPage from "@/pages/AssignmentPage";
import SuccessPage from "@/pages/SuccessPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminCandidateDetailPage from "@/pages/AdminCandidateDetailPage";
import AdminFilesPage from "@/pages/AdminFilesPage";

function App() {
  return (
    <div className="App bg-[#09090b] min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/start" element={<StartFormPage />} />
          <Route path="/assignment/:candidateId" element={<AssignmentPage />} />
          <Route path="/success/:candidateId" element={<SuccessPage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/candidate/:candidateId" element={<AdminCandidateDetailPage />} />
          <Route path="/admin/files" element={<AdminFilesPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0e0e10",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fafafa",
          },
        }}
      />
    </div>
  );
}

export default App;
